BaseCollection = require('base/collection')

class ProfileUserCollection extends BaseCollection
  url: -> 'salesforce/profile/users'

module.exports = ProfileUserCollection
